// TODO: (vliu) This is used in architect only and can be removed after we update architect
// to use same list style as recordings page

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { Clear } from '@mui/icons-material';
import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components/macro';

import { SVGIconButton } from './SVGIconButton';

const StyledInputChip = styled.div`
  padding: 4px 10px; /* top|bottom left|right */

  border-radius: 14px;
  border: 1px solid ${(props) => props.theme.chipBorder};

  /* The chip should not be larger than its container */
  max-width: 100%;

  /* The chip should stay on one row */
  display: grid;
  grid-template-columns: 1fr auto; /* text | delete icon */
  gap: 2px;
  align-items: center;
`;

const StyledInputChipList = styled.div<{ height: string | undefined }>`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  row-gap: 6px;

  /* When a height is given, allow the list of chips to overflow */
  ${(props) => props.height && `overflow-y: auto;`}
  ${(props) => props.height && `max-height: ${props.height};`}
`;

const InputChip: React.FC<{
  name: string;
  onRemove?: (removedItem: string) => void;
}> = ({ name, onRemove }) => {
  const themeContext = useContext(ThemeContext);

  return (
    <StyledInputChip>
      <div className="ellipsis">{name}</div>
      {/* Only add a cross to delete the chip when an onRemove function is given */}
      {onRemove ? (
        <SVGIconButton
          color={themeContext.chipIconColor}
          size="18px"
          onClick={() => onRemove(name)}
        >
          <Clear />
        </SVGIconButton>
      ) : null}
    </StyledInputChip>
  );
};

const InputChipList: React.FC<{
  names: string[];
  onRemove?: (removedItem: string) => void;
  height?: string;
}> = ({ names, onRemove, height }) => (
  <StyledInputChipList height={height}>
    {names.map((tagName) => (
      <InputChip name={tagName} key={tagName} onRemove={onRemove} />
    ))}
  </StyledInputChipList>
);

export { InputChipList, InputChip };
